export { default as Icon } from './Icon'
export { IconStyled } from './Icon.styles'
export { IconName } from './Icon.types'
export type { IconSize } from './Icon.types'
